export const WYND = 'wynd';
export const DEFAULT_ICON_SIZE = 'lg';